import { render } from "./sandbox.vue?vue&type=template&id=1a6fbe9e&scoped=true"
import script from "./sandbox.vue?vue&type=script&lang=js"
export * from "./sandbox.vue?vue&type=script&lang=js"

import "./sandbox.vue?vue&type=style&index=0&id=1a6fbe9e&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6fbe9e"]])

export default __exports__